// source: v3/types/bill_run.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
goog.exportSymbol('proto.loopup.ctgateway.v3.BillRun', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.BillRun = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v3.BillRun, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.BillRun.displayName = 'proto.loopup.ctgateway.v3.BillRun';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.BillRun.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.BillRun.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.BillRun} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.BillRun.toObject = function(includeInstance, msg) {
  var f, obj = {
    billingIntervalId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    customerName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    billingEntityName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    accountReference: jspb.Message.getFieldWithDefault(msg, 4, ""),
    finalAmoutDue: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
    finalTaxApplied: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
    currencyCode: jspb.Message.getFieldWithDefault(msg, 7, ""),
    invoiceId: (f = msg.getInvoiceId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    invoiceNumber: (f = msg.getInvoiceNumber()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    effectiveFromDateTime: (f = msg.getEffectiveFromDateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    endDateTime: (f = msg.getEndDateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.BillRun}
 */
proto.loopup.ctgateway.v3.BillRun.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.BillRun;
  return proto.loopup.ctgateway.v3.BillRun.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.BillRun} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.BillRun}
 */
proto.loopup.ctgateway.v3.BillRun.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBillingIntervalId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomerName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setBillingEntityName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountReference(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setFinalAmoutDue(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setFinalTaxApplied(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrencyCode(value);
      break;
    case 8:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setInvoiceId(value);
      break;
    case 9:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setInvoiceNumber(value);
      break;
    case 10:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEffectiveFromDateTime(value);
      break;
    case 11:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEndDateTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.BillRun.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.BillRun.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.BillRun} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.BillRun.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBillingIntervalId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCustomerName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getBillingEntityName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAccountReference();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getFinalAmoutDue();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getFinalTaxApplied();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getCurrencyCode();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getInvoiceId();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getInvoiceNumber();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getEffectiveFromDateTime();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEndDateTime();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string billing_interval_id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v3.BillRun.prototype.getBillingIntervalId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.BillRun} returns this
 */
proto.loopup.ctgateway.v3.BillRun.prototype.setBillingIntervalId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string customer_name = 2;
 * @return {string}
 */
proto.loopup.ctgateway.v3.BillRun.prototype.getCustomerName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.BillRun} returns this
 */
proto.loopup.ctgateway.v3.BillRun.prototype.setCustomerName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string billing_entity_name = 3;
 * @return {string}
 */
proto.loopup.ctgateway.v3.BillRun.prototype.getBillingEntityName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.BillRun} returns this
 */
proto.loopup.ctgateway.v3.BillRun.prototype.setBillingEntityName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string account_reference = 4;
 * @return {string}
 */
proto.loopup.ctgateway.v3.BillRun.prototype.getAccountReference = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.BillRun} returns this
 */
proto.loopup.ctgateway.v3.BillRun.prototype.setAccountReference = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional double final_amout_due = 5;
 * @return {number}
 */
proto.loopup.ctgateway.v3.BillRun.prototype.getFinalAmoutDue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v3.BillRun} returns this
 */
proto.loopup.ctgateway.v3.BillRun.prototype.setFinalAmoutDue = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional double final_tax_applied = 6;
 * @return {number}
 */
proto.loopup.ctgateway.v3.BillRun.prototype.getFinalTaxApplied = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v3.BillRun} returns this
 */
proto.loopup.ctgateway.v3.BillRun.prototype.setFinalTaxApplied = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional string currency_code = 7;
 * @return {string}
 */
proto.loopup.ctgateway.v3.BillRun.prototype.getCurrencyCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.BillRun} returns this
 */
proto.loopup.ctgateway.v3.BillRun.prototype.setCurrencyCode = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional google.protobuf.StringValue invoice_id = 8;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v3.BillRun.prototype.getInvoiceId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 8));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v3.BillRun} returns this
*/
proto.loopup.ctgateway.v3.BillRun.prototype.setInvoiceId = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.BillRun} returns this
 */
proto.loopup.ctgateway.v3.BillRun.prototype.clearInvoiceId = function() {
  return this.setInvoiceId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.BillRun.prototype.hasInvoiceId = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional google.protobuf.StringValue invoice_number = 9;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v3.BillRun.prototype.getInvoiceNumber = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 9));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v3.BillRun} returns this
*/
proto.loopup.ctgateway.v3.BillRun.prototype.setInvoiceNumber = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.BillRun} returns this
 */
proto.loopup.ctgateway.v3.BillRun.prototype.clearInvoiceNumber = function() {
  return this.setInvoiceNumber(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.BillRun.prototype.hasInvoiceNumber = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional google.protobuf.Timestamp effective_from_date_time = 10;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.loopup.ctgateway.v3.BillRun.prototype.getEffectiveFromDateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 10));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.loopup.ctgateway.v3.BillRun} returns this
*/
proto.loopup.ctgateway.v3.BillRun.prototype.setEffectiveFromDateTime = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.BillRun} returns this
 */
proto.loopup.ctgateway.v3.BillRun.prototype.clearEffectiveFromDateTime = function() {
  return this.setEffectiveFromDateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.BillRun.prototype.hasEffectiveFromDateTime = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional google.protobuf.Timestamp end_date_time = 11;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.loopup.ctgateway.v3.BillRun.prototype.getEndDateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 11));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.loopup.ctgateway.v3.BillRun} returns this
*/
proto.loopup.ctgateway.v3.BillRun.prototype.setEndDateTime = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.BillRun} returns this
 */
proto.loopup.ctgateway.v3.BillRun.prototype.clearEndDateTime = function() {
  return this.setEndDateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.BillRun.prototype.hasEndDateTime = function() {
  return jspb.Message.getField(this, 11) != null;
};


goog.object.extend(exports, proto.loopup.ctgateway.v3);
